<template>
    <span :data-bs-toggle="toolTip ? 'tooltip' : null" :data-bs-placement="toolTip ? 'top' : null" :title="toolTip ? toolTip : null">
        <font-awesome-icon 
            :icon="['fas', awesomeIcon]" 
            :class="bootstrapColor"
            :size="size" 
            class="mx-1"/>
    </span>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'blue'
        },
        size: {
            type: String,
            default: "l"
        },
        toolTip: {
            type: [String, null],
            default: null
        },
    },
    computed: {
        awesomeIcon: function () {
            switch (this.icon) {
                case 'info':
                    return 'fa-circle-info'
                case 'pen':
                    return 'fa-pen'
                case 'check':
                    return 'fa-check'
                case 'cross':
                    return 'fa-xmark'
                case 'link':
                    return 'fa-arrow-up-right-from-square'
                case 'circle':
                    return 'fa-circle'
                default:
                    return 'fa-circle-info'
            }
        },
        bootstrapColor: function () {
            switch (this.color) {
                case 'blue':
                    return 'text-primary'
                case 'blue-light':
                    return 'text-info'
                case 'red':
                    return 'text-danger'
                case 'green':
                    return 'text-success'
                case 'gray':
                    return 'text-muted'
                case 'orange':
                    return 'text-warning'
                default:
                    return 'text-primary'
            }
        }
    },
}
</script>